/** Shared in-play ball indicator dots (Squares ball-results strip). */
export const BALL_IN_PROGRESS_DOT_BASE_CLASS =
    "h-[3px] w-[3px] shrink-0 rounded-full animate-bounce";

/** 100% → 70% → 40% white. */
export const BALL_IN_PROGRESS_DOT_OPACITY_CLASSES = [
    "bg-white",
    "bg-white/70",
    "bg-white/40",
];

export const BALL_IN_PROGRESS_DOT_DELAYS_MS = [0, 150, 300];
